import { Component, Input, Output, EventEmitter, OnInit, Pipe, PipeTransform } from '@angular/core';
import { BObjectModel } from '../models/bodisplay';
import { AccesPortailModel } from '../models/acces-portail/acces-portail.model';
import { CoreService, HttpService } from '../services';
import { ToastService } from '../toast';

@Pipe({
  name: 'isNumeric'
})
export class IsNumericPipe implements PipeTransform {
  transform(value: string): boolean {
    if (!value) return true;
    for (let i: number = 0; i < value.length; i++)
    {
      const parsed = parseInt(value[i]);
      if (isNaN(parsed))
        return false;
    }
    return true;
  }
}

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-acces-portail',
  templateUrl: './acces-portail.component.html',
  styleUrls: ['./acces-portail.component.css']
})
export class AccesPortailComponent {
  public model: AccesPortailModel = new AccesPortailModel();
  public sendingMail: boolean = false;
  public isSaving: boolean = false;
  @Input('idPersonne') set SetIdPersonne(value: string) {
    if (value) {
      this.http.getHttp<AccesPortailModel>(`${this.indParam.AppParams.apiUrl}api/PageAccesPortail/CREATEMODEL/${value}`).subscribe(
        (result: AccesPortailModel) => {
          this.model = result;
          this.model.idPersonne = value;
        })
    }
  }
  @Output() save: EventEmitter<AccesPortailModel> = new EventEmitter<AccesPortailModel>(false);
  @Output() cancel: EventEmitter<AccesPortailModel> = new EventEmitter<AccesPortailModel>(true);

  constructor(
    public http: HttpService,
    public indParam: CoreService,
    private isNumeric: IsNumericPipe,
    private toast: ToastService,
  ) { }

  public OnSave(): void {
    if (this.isSaving) {
      this.toast.showInfoToast('Une sauvegarde est déjà en cours.');
      return;
    }
    if (this.model.Role_PER.value === '') {
      this.toast.showAlertToast('Aucun niveau de role sélectionné.');
      return;
    }
    if (!this.isNumeric.transform(this.model.PassePER.value)) {
      // RAZ du mot de passe non numérique
      this.model.PassePER.value = '';     
    }

    const saveModel = JSON.parse(JSON.stringify(this.model));
    saveModel.Mode = "SAVE";
    this.isSaving = true;
    this.http.postHttp<AccesPortailModel>(`${this.indParam.AppParams.apiUrl}api/PageAccesPortail`, saveModel).subscribe(
      (result: AccesPortailModel) => {
        this.isSaving = false;
        this.model = result;
        this.save.emit(result);
      });
  
  }

  public OnCancel(): void {
    if (this.isSaving) {
      this.toast.showInfoToast('Une sauvegarde est déjà en cours.');
      return;
    }
    const saveModel = JSON.parse(JSON.stringify(this.model));
    saveModel.Mode = "DELETE";
    this.isSaving = true;
    this.http.postHttp<AccesPortailModel>(`${this.indParam.AppParams.apiUrl}api/PageAccesPortail`, saveModel).subscribe(
      (result: AccesPortailModel) => {
        this.isSaving = false;
        this.model = result;
        this.cancel.emit(result);
      });
  }

  public SendMail(): void {
    if (this.model.NeproPER.value) {
      this.sendingMail = true;
      this.http.getHttp<AccesPortailModel>(`${this.indParam.AppParams.apiUrl}api/PageAccesPortail/SEND_MAIL/${this.model.idPersonne}`).subscribe(() => { this.sendingMail = false;});
    }
  }
}
